import { APIError } from "../constants/types"
import { showMessage } from "../redux/messages/messagesActions";


export  const triggerErrorDialogMessages = (err: APIError, dispatch: any) => {
  dispatch(
    showMessage({
      message: err.message,
      type: "error",
      displayAs: "dialog",
    }),
  );
}

export const triggerSuccessDialogMessages = (message: string, dispatch: any) => {
  dispatch(
    showMessage({
      message: message,
      type: "success",
      displayAs: "dialog",
    }),
  );
}